import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-m text-racq-med-grey py-4"
}
const _hoisted_2 = {
  key: 0,
  class: "text-racq-grey"
}
const _hoisted_3 = {
  key: 1,
  class: "text-racq-grey"
}
const _hoisted_4 = { class: "py-4 border-b grid grid-cols-1 gap-2" }

import Pagination from '@/components/Pagination/Pagination.vue';
import { scrollToElement } from '@/utils/dom-helpers';
import { computed, ref, watch } from 'vue';
import { Field, RichText } from '@sitecore-jss/sitecore-jss-vue';
import { replaceBookmark } from '@/utils/bookmark.replace';

interface Props {
  items: any[];
  content: {
    lastUpdatedLabel: Field<string>;
    resultCountLabel: Field<string>;
    paginationPrevLabel: Field<string>;
    paginationNextLabel: Field<string>;
  };
  itemsPerPage?: number;
  defaultPage?: number;
  lastUpdatedAt?: string;
  showPagination?: boolean;
  scrollTarget?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchResultsList',
  props: {
    items: {},
    content: {},
    itemsPerPage: { default: 10 },
    defaultPage: { default: 1 },
    lastUpdatedAt: { default: '' },
    showPagination: { type: Boolean, default: true },
    scrollTarget: { default: '' }
  },
  emits: ["pageChanged"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const currentPage = ref(props.defaultPage);

const paginatedItems = computed(() => {
  return props.items.slice((currentPage.value - 1) * props.itemsPerPage, currentPage.value * props.itemsPerPage);
});

const lastUpdatedLabel = computed(() => {
  return replaceBookmark('lastUpdatedAt', props.content.lastUpdatedLabel?.value ?? '', props.lastUpdatedAt);
});

const resultCountLabel = computed(() => {
  return replaceBookmark('count', props.content.resultCountLabel?.value ?? '', props.items.length.toString());
});

const updatePage = (page: number) => {
  currentPage.value = page;
  emit('pageChanged', page);

  if (props.scrollTarget) {
    scrollToElement(props.scrollTarget);
  }
};

// Reset to first page when items change
watch(
  () => props.items,
  () => {
    currentPage.value = 1;
  },
  {
    deep: true,
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.items.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "header", {}, () => [
            (resultCountLabel.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(resultCountLabel.value), 1))
              : _createCommentVNode("", true),
            (lastUpdatedLabel.value && _ctx.lastUpdatedAt)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(lastUpdatedLabel.value), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "subHeader"),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedItems.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "max-w-[920px]"
      }, [
        _renderSlot(_ctx.$slots, "item", {
          item: item,
          index: index,
          isLast: index === paginatedItems.value.length - 1
        }, () => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(RichText), {
              tag: item.url ? 'a' : 'div',
              href: item.url,
              class: _normalizeClass(["text-base md:text-xl-bold link", { 'text-racq-dark-grey': !item.url }]),
              field: { value: item.title }
            }, null, 8, ["tag", "href", "class", "field"]),
            _createVNode(_unref(RichText), {
              class: "text-sm text-racq-med-grey",
              field: { value: item.description }
            }, null, 8, ["field"])
          ])
        ])
      ]))
    }), 128)),
    (_ctx.items?.length && _ctx.showPagination)
      ? (_openBlock(), _createBlock(Pagination, {
          key: 1,
          total: _ctx.items.length,
          itemsPerPage: _ctx.itemsPerPage,
          defaultPage: currentPage.value,
          onUpdatePage: updatePage
        }, null, 8, ["total", "itemsPerPage", "defaultPage"]))
      : _createCommentVNode("", true)
  ]))
}
}

})